module.exports = __webpack_public_path__ + "img/in_app_screenshot.cf903548.png";